import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import config from './config.js'

Vue.use(VueRouter)

import Home from './pages/Home.vue'
import Category from './pages/Category.vue'
import Shopcart from './pages/Shopcart.vue'
import User from './pages/User.vue'
import Login from './pages/user/Login.vue'
import Register from './pages/user/Register.vue'
import GoodsList from './pages/goods/GoodsList.vue'
import GoodsInfo from './pages/goods/GoodsInfo.vue'
import Address from './pages/user/Address.vue'
import AddressEdit from './pages/user/AddressEdit.vue'
import OrderCreate from './pages/order/OrderCreate.vue'
import OrderList from './pages/order/OrderList.vue'
import OrderShow from './pages/order/OrderShow.vue'
import NewsList from './pages/news/NewsList.vue'
import NewsInfo from './pages/news/NewsInfo.vue'
import PhotoList from './pages/photo/PhotoList.vue'
import PhotoInfo from './pages/photo/PhotoInfo.vue'
import UserListAdmin from './pages/admin/UserListAdmin.vue'
import GoodsListAdmin from './pages/admin/GoodsListAdmin.vue'
import OrderListAdmin from './pages/admin/OrderListAdmin.vue'
import GoodsInfoAdmin from './pages/admin/GoodsInfoAdmin.vue'
import Admin from './pages/admin/Admin.vue'
import store from './store'
import UpdatePassword from './pages/user/UpdatePassword.vue'
import PointsLog from './pages/user/PointsLog.vue'

var router = new VueRouter({
  routes: [
    { path: '/', redirect: '/goods/goodslist', meta: { title: '商品' } },
    // { path: '/home', component: Home, name: 'home', meta: { title: '首页' } },
    // { path: '/category', component: Category, name: 'category', meta: { title: '商品' } },
    { path: '/shopcart', component: Shopcart, name: 'shopcart', meta: { title: '购物车' } },
    { path: '/user', component: User, name: 'user', meta: { title: '我的' } },
    { path: '/user/login', component: Login, name: 'login', meta: { title: '登录' } },
    { path: '/user/register', component: Register, name: 'register', meta: { title: '注册' } },
    { path: '/goods/goodslist', component: GoodsList, props: true, name: 'goods_list', meta: { title: '商品列表' } },
    { path: '/goods/goodsinfo/:id', component: GoodsInfo, props: true, name: 'goods_info', meta: { title: '商品信息' } },
    { path: '/user/address', component: Address, name: 'address', meta: { title: '收货地址' } },
    { path: '/user/address/add', component: AddressEdit, name: 'address_add', meta: { title: '新增收货地址' } },
    { path: '/user/address/edit/:id', component: AddressEdit, props: true, name: 'address_edit', meta: { title: '编辑收货地址' } },
    { path: '/user/update', component: UpdatePassword,props: true,name:'update_password',meta:{ title :'更改密码' }},
    { path: '/user/points-log', component: PointsLog, name: 'points_log', meta: { title: '积分记录' } },
    { path: '/order/create', component: OrderCreate, name: 'order_create', meta: { title: '下订单' } },
    { path: '/user/address/select', component: Address, name: 'address_select', meta: { title: '选择收货地址' } },
    { path: '/order/list', component: OrderList, name: 'order_list', meta: { title: '我的订单' } },
    { path: '/order/show/:id', component: OrderShow, props: true, name: 'order_show', meta: { title: '查看订单' } },
    { path: '/news/list', component: NewsList, name: 'news_list', meta: { title: '新闻资讯列表' } },
    { path: '/news/show/:id', component: NewsInfo, props: true, name: 'news_show', meta: { title: '查看新闻资讯' } },
    { path: '/photo/list', component: PhotoList, name: 'photo_list', meta: { title: '图片分享列表' } },
    { path: '/photo/show/:id', component: PhotoInfo, props: true, name: 'photo_show', meta: { title: '查看图片' } },
    { path: '/admin',component:Admin,name:'admin', meta:{title:'后台管理',requiresAuth:true}},
    { path: '/admin/user', component: UserListAdmin, meta: { title: '用户管理', requiresAuth: true } },
    { path: '/admin/goods', component: GoodsListAdmin, meta: { title: '商品管理', requiresAuth: true } },
    { path: '/admin/order', component: OrderListAdmin, meta: { title: '订单管理', requiresAuth: true } },
    { path: '/admin/goods_info', component: GoodsInfoAdmin, meta: { title: '商品编辑', requiresAuth: true }}
  ],
  linkActiveClass: 'mui-active'
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next();
    return;
  }

  const currentUserId = store.state.user.id;
  const savedAuthorization = localStorage.getItem('Authorization');

  if (!currentUserId && savedAuthorization) {
    try {
      const response = await axios.get(`${config.baseURL}/user`, {
        withCredentials: true,
        headers: {
          Authorization: savedAuthorization
        }
      });

      if (response.data.code === 1) {
        store.commit('user/setUser', response.data.data);
      } else {
        localStorage.removeItem('Authorization');
        store.commit('user/logout');
      }
    } catch (error) {
      localStorage.removeItem('Authorization');
      store.commit('user/logout');
    }
  }

  const isAuthenticated = store.getters['user/isLogin'];
  if (!isAuthenticated) {
    next('/user/login');
    return;
  }

  const isAdmin = store.state.user.username === 'admin';
  if (!isAdmin) {
    next('/');
    return;
  }

  next();
});


export default router
